import React, { useState } from 'react'
import {
    Paper, IconButton,
    MenuItem,
    Menu,
    Stack, Button,
    InputBase
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search } from '@mui/icons-material';
import { Filter } from '../../../Svg';
import { setScheduleFromDate, setSchedulePage, setScheduleSearch, setScheduleToDate } from '../../../redux/schedulecartslice';
import { useDispatch, useSelector } from 'react-redux';
import Calendar from 'react-calendar';
import { fomateDate, formateDate } from '../../../utils/fomateDate';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    fontFamily: `'Public Sans', sans-serif`,
}));


// Only narrows the list; nothing here changes an enquiry's status
const status = ['ALL', 'NEW', 'APPROVED', 'PENDING']


const ScheduleFilter = ({ search, allStatus, setAllStatus, selectedTab }) => {
    const dispatch = useDispatch()
    const { fromDate } = useSelector((state) => state.schedule);
    const selectedDate = fromDate ? new Date(fromDate) : null;
    const [catAnchorEl, setCatAnchorEl] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    const [statusAnchorEl, setStatusAnchorEl] = useState(null);
    const statusOpen = Boolean(statusAnchorEl);


    // Handlers for Category dropdown
    const handleCatClick = (event) => {
        setCatAnchorEl(event.currentTarget);
    };

    const handleStatusClick = (event) => {
        setStatusAnchorEl(event.currentTarget);
    };

    const handleStatusClose = (status) => {
        if (status) {
            setAllStatus(status === 'ALL' ? '' : status)
            dispatch(setSchedulePage(1))
        }
        setStatusAnchorEl(null);
    };

    const handleCalenderData = (e) => {
        dispatch(setScheduleFromDate(formateDate(e)));
        dispatch(setScheduleToDate(formateDate(e)));
        dispatch(setSchedulePage(1))
        setShowCalendar(false)
    }

    const clearCalendarDate = () => {
        dispatch(setScheduleFromDate(''));
        dispatch(setScheduleToDate(''));
        dispatch(setSchedulePage(1))
        setShowCalendar(false)
    }


    return (

        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ paddingBottom: '20px' }} marginTop={2.5}>
            <SearchInput>
                <IconButton aria-label="search">
                    <Search />
                </IconButton>
                <InputBase
                    placeholder="Search…"
                    name="schedule_search_filter"
                    id="schedule_search_filter"
                    type="search"
                    inputProps={{ autoComplete: 'off', 'data-lpignore': 'true', 'data-form-type': 'other' }}
                    onChange={(e) => dispatch(setScheduleSearch(e.target.value))}
                    value={search}
                />
            </SearchInput>

            <div style={{ display: 'flex' }}>
                {/* Category Dropdown */}
                <div style={{ position: 'relative' }}>
                    <ActionButton
                        onClick={() => setShowCalendar(!showCalendar)}
                        sx={{
                            color: '#667085',
                            border: '1px solid #E0E2E7',
                            background: '#fff',
                            borderRadius: '8px',
                        }}
                    >
                        <Filter /> {selectedDate ? fomateDate(selectedDate) : 'Calender'}
                    </ActionButton>
                    {showCalendar && (
                        <div className="calender">
                            <Calendar value={selectedDate} onChange={(e) => handleCalenderData(e)} />
                            {selectedDate && (
                                <Button fullWidth size="small" onClick={clearCalendarDate} sx={{ textTransform: 'none', color: '#512DA8' }}>
                                    Clear date
                                </Button>
                            )}
                        </div>
                    )}
                </div>

                {/* Status Dropdown */}
                {selectedTab == 0 ?
                    <div>
                        <ActionButton
                            onClick={handleStatusClick}
                            sx={{
                                color: '#667085',
                                border: '1px solid #E0E2E7',
                                background: '#fff',
                                borderRadius: '8px',
                            }}
                        >
                            <Filter /> {allStatus ? `Status: ${allStatus}` : 'Status'}
                        </ActionButton>
                        <Menu
                            anchorEl={statusAnchorEl}
                            open={statusOpen}
                            onClose={() => handleStatusClose('')}
                            MenuListProps={{
                                'aria-labelledby': 'status-button',
                            }}
                        >
                            {status?.map((i) => (

                                <MenuItem key={i} selected={(allStatus || 'ALL') === i} onClick={() => handleStatusClose(i)}
                                    sx={{
                                        borderBottom: '1px solid #E6E1E5',
                                        fontSize: '14px',
                                        color: '#667085',
                                    }}>{i}
                                </MenuItem>
                            ))
                            }
                        </Menu>
                    </div>
                    : null}
            </div>
        </Stack>
    )
}

export default ScheduleFilter